import { ModelObject } from '@cco/model';

export interface Dimension extends ModelObject<number> {
  name: string;
}

/**
 * To regenerate this reference class, execute the following query:
 * SELECT 'public static readonly ' || replace(upper(name), ' ', '_') || ': Dimension = { id: ' || id || ', name: ''' || name || ''' };' FROM dimension;
 */
export class Dimensions {
  public static readonly ALL_DIMENSION_IDS = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
  ];
  public static readonly LENGTH: Dimension = { id: 1, name: 'Length' };
  public static readonly MASS: Dimension = { id: 2, name: 'Mass' };
  public static readonly AREA: Dimension = { id: 3, name: 'Area' };
  public static readonly VOLUME: Dimension = { id: 4, name: 'Volume' };
  public static readonly TIME: Dimension = { id: 5, name: 'Time' };
  public static readonly TEMPERATURE: Dimension = { id: 6, name: 'Temperature' };
  public static readonly CURRENT: Dimension = { id: 7, name: 'Current' };
  public static readonly LUMINOUS_INTENSITY: Dimension = { id: 8, name: 'Luminous Intensity' };
  public static readonly AMOUNT_OF_MATTER: Dimension = { id: 9, name: 'Amount of Matter' };
  public static readonly FORCE: Dimension = { id: 10, name: 'Force' };
  public static readonly ACCELERATION: Dimension = { id: 11, name: 'Acceleration' };
  public static readonly PRESSURE: Dimension = { id: 12, name: 'Pressure' };
  public static readonly ENERGY: Dimension = { id: 13, name: 'Energy' };
  public static readonly POWER: Dimension = { id: 14, name: 'Power' };
  public static readonly PERCENTAGE: Dimension = { id: 15, name: 'Percentage' };
  public static readonly NONE: Dimension = { id: 16, name: 'None' };
  public static readonly DENSITY: Dimension = { id: 17, name: 'Density' };
  public static readonly VOLUME_RATE: Dimension = { id: 18, name: 'Volume Rate' };
  public static readonly VOLUME_PER_MASS: Dimension = { id: 19, name: 'Volume per Mass' };
  public static readonly SPEED: Dimension = { id: 20, name: 'Speed' };
  public static readonly FREQUENCY: Dimension = { id: 21, name: 'Frequency' };
}
